// kapigen version 0.1.34
// eslint-disable
// namespace Kaggle.Sdk.Security:
// The structured reason/justification for accessing another user's data.
// This was patterned after
// http://google3/security/credentials/proto/authenticator.proto;l=309;rcl=439326919
export var DataAccessReasonWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
